/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportDetailsView } from './ReportDetailsView';
import type { ReportSummaryView } from './ReportSummaryView';
export type ReportView = {
    /**
     * Payload shape version
     */
    schemaVersion?: number;
    reportId?: string;
    shopId?: string;
    shopHost?: string;
    frequency?: ReportView.frequency;
    /**
     * Inclusive period start (Europe/Berlin)
     */
    periodStart?: string;
    /**
     * Inclusive period end (Europe/Berlin)
     */
    periodEnd?: string;
    comparisonStart?: string;
    comparisonEnd?: string;
    /**
     * Currency all amounts are given in
     */
    currency?: string | null;
    /**
     * Unpaid orders in the period
     */
    unpaidOrders?: number | null;
    /**
     * Unshipped orders in the period
     */
    unshippedOrders?: number | null;
    summary: ReportSummaryView;
    details: ReportDetailsView;
};
export namespace ReportView {
    export enum frequency {
        DAILY = 'daily',
        WEEKLY = 'weekly',
        MONTHLY = 'monthly',
    }
}

